const useHideTippyOnChildrenClick = (instance) => {
  const handler = () => {
    instance.popper.removeEventListener("click", handler);
    instance.hide();
  };
  instance.popper.addEventListener("click", handler);
};

export default useHideTippyOnChildrenClick;
